;(function () {

"use strict";

var ModalView = require('./modal');
var EmailSignupTemplate = require('./templates/email-signup-modal.html');
var NewsletterFormView = require('./newsletter-form');
var copy = require('copy-to-clipboard');

var addNotification = function (el, str) {
  var $alert = $('<div class="alert">'+str+'</div>');

  $(el).append($alert);
  setTimeout(function () {
    $alert.addClass('visible');
  }, 0);

  setTimeout(function () {
    $alert.addClass('out');
  }, 1000);

  setTimeout(function () {
    $alert.remove();
  }, 2000);
};

var EmailSignupModalView = ModalView.extend({
  className: 'email-signup-modal modal',
  initialize: function (opts) {
    // console.log('init email signup modal view');

    if ($('header .mobile').is(':visible')) {
      return;      
    }    

    opts = opts || {};
    opts.content = EmailSignupTemplate;

    ModalView.prototype.initialize.call(this, opts);

    this.render().show();

    var self = this;
    new NewsletterFormView({ 
      el: this.$el.find('form'), 
      onSuccess: function () {
        _.delay(function () { self.showCode(); }, 1250);
      } 
    });
  },
  showCode: function () {
    this.$el.find('button.close');
    this.$el.find('.content').addClass('subscribed');

    var $code = $('<div class="code"><span>PLAYTIME10</span></div>')

    /* Auto apply */
    $.get('https://www.roseandrex.com/discount/PLAYTIME10');

    $code.on('click', function (e) {
      // console.log('copy');
      copy('PLAYTIME10', { message: 'Press ⌘-C to copy' });

      addNotification(this, 'Copied to clipboard!');

      return false;
    });

    $code.insertAfter(this.$el.find('.content .hidden-pane h5'));
    $code.addClass('active');


    window.Cookies.set('submitted_email', 'true', { expires: 365 });

    // this.hide();
  },
  submit: function (e) {
    // console.log('submit subsciption form');

    return false;
  }
});

module.exports = EmailSignupModalView;

}());